<template>
    <span>
        <BPopover :show.sync="editing" :target="thisRef" triggers="blur focus">
            <template #title>
                <BButton aria-label="Close" class="close" @click="toggle">
                    <span aria-hidden="true" class="d-inline-block"
                        >&times;</span
                    >
                </BButton>
                Edit Value
            </template>

            <slot name="edit"></slot>
        </BPopover>
        <div :id="thisRef" class="editable" @click="toggle">
            <slot name="display"></slot>
        </div>
    </span>
</template>

<script>
import { BButton, BPopover } from "bootstrap-vue";

export default {
    name: "OInlineWidget",
    components: {
        BPopover,
        BButton,
    },
    data() {
        return {
            editing: false,
            thisRef: "dummy",
        };
    },
    mounted() {
        this.thisRef = "popup" + this._uid;
    },
    methods: {
        toggle() {
            this.$root.$emit("bv::hide::popover");

            this.editing = !this.editing;
        },
    },
};
</script>

<style scoped>
.editable {
    text-decoration: underline dotted;
}

.popup {
    position: relative;
    display: inline-block;
    z-index: 777;
    top: 0;
    left: 0;
    min-width: 100px;
    min-height: 20px;
    background-color: silver;
}
</style>
